export default class LdapConfig {
    public id: number | null = null;
    public enabled: boolean = false;
    public host: string = "";
    public port: number = 636;
    public encryption: string = "LDAPS";
    public bindDn: string = "";
    public bindPassword: string = "";
    public userBaseDn: string = "";
    public userFilter: string = "";
    public emailAttribute: string = "mail";
    public emailDomains: string = "";
}
